/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

import "../debugInfo.js"; // Vite 8: ensure debugInfo namespace is initialized first

/**
 * @ignore
 */
gbc.constants.debugInfo.attributeCategory = {
  acceleratorKey1: "General",
  acceleratorKey3: "General",
  acceleratorName: "General",
  acceleratorName2: "General",
  acceleratorName3: "General",
  acceleratorName4: "General",
  accessoryType: "General",
  action: "General",
  actionActive: "General",
  actionIdRef: "General",
  active: "General",
  aggregateText: "General",
  aggregateType: "General",
  aggregateValue: "General",
  anchor: "General",
  autoNext: "General",
  autoScale: "General",
  blink: "TTY",
  bold: "TTY",
  border: "General",
  bufferSize: "General",
  build: "General",
  buttonTextHidden: "General",
  century: "General",
  charLengthSemantics: "General",
  className: "General",
  clickedCanvasItemId: "General",
  cloneColumns: "General",
  cloneCount: "General",
  colName: "General",
  color: "TTY",
  colorCondition: "TTY",
  columnCount: "General",
  comment: "General",
  commentLine: "General",
  commentLineHidden: "General",
  componentType: "General",
  compress: "General",
  config: "General",
  container: "General",
  contextMenu: "General",
  content: "General",
  context: "General",
  count: "General",
  currentColumn: "General",
  currentParentRow: "General",
  currentRow: "General",
  currentWindow: "General",
  cursor: "General",
  cursor2: "General",
  dataType: "General",
  dbCentury: "General",
  dbDate: "General",
  decimalSeparator: "General",
  defaultValue: "General",
  defaultView: "General",
  delimiters: "General",
  detailAction: "General",
  dialogEventItem: "General",
  dialogEventType: "General",
  dialogType: "General",
  diameter: "General",
  dim: "TTY",
  dirty: "General",
  disabled: "General",
  disclosureIndicator: "General",
  dndAccepted: "General",
  dndBuffer: "General",
  dndCanCopy: "General",
  dndCanMove: "General",
  dndFeedback: "General",
  dndIdRef: "General",
  dndMimeTypes: "General",
  dndOperation: "General",
  dndRequiredMimeType: "General",
  doubleClick: "General",
  endX: "General",
  endY: "General",
  errorLine: "General",
  exec: "General",
  expanded: "General",
  expandedColumn: "General",
  extentDegrees: "General",
  fieldId: "General",
  fieldIdRef: "General",
  fieldOrder: "General",
  fieldSelection: "General",
  fileName: "General",
  fillColor: "General",
  filter: "General",
  flipped: "General",
  focus: "General",
  focusOnField: "General",
  fontPitch: "General",
  formLine: "General",
  format: "General",
  gridChildrenInParent: "Layout",
  gridHeight: "Layout",
  gridWidth: "Layout",
  hasChildren: "General",
  haveRowActions: "General",
  height: "Layout",
  helpNum: "General",
  hidden: "Layout",
  href: "General",
  idColumn: "General",
  idRef: "General",
  image: "General",
  imageCollapsed: "General",
  imageColumn: "General",
  imageExpanded: "General",
  imageLeaf: "General",
  include: "General",
  initializer: "General",
  inputWrap: "General",
  isHotKey: "General",
  isNodeColumn: "General",
  isNull: "General",
  isPassword: "TTY",
  isSystem: "General",
  isTimer: "General",
  isTree: "General",
  justify: "General",
  keyboardHint: "General",
  maxLength: "General",
  media: "Responsive",
  mediaAttribute: "Responsive",
  menuLine: "General",
  messageLine: "General",
  minHeight: "Layout",
  minWidth: "Layout",
  moduleName: "General",
  multiRowSelection: "General",
  name: "General",
  noEntry: "General",
  noFilter: "General",
  nodeIdRef: "General",
  notEditable: "General",
  notNull: "General",
  noswipe: "Responsive",
  numAlign: "General",
  offset: "General",
  orientation: "General",
  pageSize: "General",
  paramCount: "General",
  parent: "General",
  parentIdColumn: "General",
  picture: "General",
  placeholder: "General",
  posX: "Layout",
  posY: "Layout",
  procId: "General",
  procIdParent: "General",
  procIdWaiting: "General",
  program: "General",
  promptLine: "General",
  queryEditable: "General",
  required: "General",
  returnCount: "General",
  reverse: "TTY",
  row: "General",
  rowBound: "General",
  runtimeStatus: "General",
  sample: "General",
  screenRecord: "General",
  scroll: "General",
  scrollBars: "General",
  selected: "General",
  selection: "General",
  shift: "General",
  size: "General",
  sizePolicy: "Layout",
  sortColumn: "General",
  sortSpec: "General",
  sortType: "General",
  spacing: "General",
  split: "Responsive",
  splitter: "General",
  sqlDbName: "General",
  sqlTabName: "General",
  sqlType: "General",
  startDegrees: "General",
  startX: "General",
  startY: "General",
  step: "General",
  stepX: "General",
  stepY: "General",
  stretch: "Layout",
  stretchColumns: "Layout",
  stretchMin: "Layout",
  stretchMax: "Layout",
  style: "General",
  tabIndex: "General",
  tabIndexRt: "General",
  tabName: "General",
  tag: "General",
  targetType: "General",
  text: "General",
  thousandsSeparator: "General",
  timeout: "General",
  touched: "General",
  ttyAttr: "General",
  type: "General",
  uiMode: "General",
  underline: "TTY",
  unhidable: "General",
  unhidableColumns: "General",
  unmovable: "General",
  unmovableColumns: "General",
  unsizable: "General",
  unsizableColumns: "General",
  unsortable: "General",
  unsortableColumns: "General",
  validate: "General",
  value: "General",
  valueChecked: "General",
  valueMax: "General",
  valueMin: "General",
  valueUnchecked: "General",
  varType: "General",
  verify: "General",
  version: "General",
  visibleId: "General",
  waiting: "General",
  wantFixedPageSize: "General",
  wantReturns: "General",
  wantTabs: "General",
  width: "Layout",
  windowStyle: "General",
  windowType: "General",
  xyList: "General"
};
